/**
 * app.js
 *
 * This is the first file loaded. It sets up the Renderer,
 * Scene and Camera. It also starts the render loop and
 * handles window resizes.
 *
 */
import { WebGLRenderer, PerspectiveCamera, Vector3, Vector2, ReinhardToneMapping,  AudioListener, Audio, AudioLoader} from 'three';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { SeedScene } from 'scenes';
import Lazer from './components/sounds/lazer.mp3';
import Music from './components/sounds/Boomerang_David_Renda.mp3';
import Ascend from './components/sounds/ascend.mp3';
import Boom from './components/sounds/exp.mp3';
import Descend from './components/sounds/descend.mp3';

let composer;

// Initialize core ThreeJS components
const scene = new SeedScene();
const camera = new PerspectiveCamera();
const renderer = new WebGLRenderer({ antialias: true });
renderer.setPixelRatio( window.devicePixelRatio );
renderer.setSize( window.innerWidth, window.innerHeight );
renderer.toneMapping = ReinhardToneMapping;
const angle = new Vector3(0,0,0);
const view = new Vector3(0,0,0);
const dir = {
    left: false,
    right: false,
    up: false,
    down: false,
    fire: false,
};
var lastShot = 0.0;

const params = {
				exposure: 1.5,
				bloomStrength: 3,
				bloomThreshold: 0.05,
				bloomRadius: 1.0
			};

// Set up camera
camera.position.set(6, 3, -10);
camera.lookAt(new Vector3(0,0,0));

// Set up renderer, canvas, and minor CSS adjustments
const canvas = renderer.domElement;
canvas.style.display = 'block'; // Removes padding below canvas
document.body.style.margin = 0; // Removes margin around page
document.body.style.overflow = 'hidden'; // Fix scrolling
document.body.appendChild(canvas);

canvas.requestPointerLock = canvas.requestPointerLock ||
    canvas.mozRequestPointerLock;

canvas.onclick = function() {
  canvas.requestPointerLock();
};

const listener = new AudioListener();
const listener2 = new AudioListener();
const listener3 = new AudioListener();
const listener4 = new AudioListener();
const listener5 = new AudioListener();
camera.add( listener );
camera.add( listener2 );
camera.add( listener3 );
camera.add( listener4 );
camera.add( listener5 );
// create a global audio source
const shots = [];
var shotIndex = 0;
// load a sound and set it as the Audio object's buffer
const audioLoader = new AudioLoader();
audioLoader.load( Lazer, function( buffer ) {
    for(var i = 0; i<4; i++){
        var sound = new Audio( listener );
        sound.setBuffer( buffer );
	      sound.setLoop( false );
	      sound.setVolume( 0.07 );
        sound.playbackRate = 2.0;
        shots.push(sound);
    }
});

//'src/components/sounds/Boomerang_David_Renda.mp3'
var music = new Audio( listener2 );
audioLoader.load( Music, function( buffer ) {
    music.setBuffer( buffer );
	  music.setLoop( true );
	  music.setVolume( 0.4 );
    music.play();
});

var exp = new Audio( listener3 );
audioLoader.load( Boom, function( buffer ) {
    exp.setBuffer( buffer );
	  exp.setLoop( false );
	  exp.setVolume( 0.35 );
    exp.playbackRate =1.5;
});
scene.state.expSound = exp;

var ascend = new Audio( listener4 );
audioLoader.load( Ascend, function( buffer ) {
    ascend.setBuffer( buffer );
	  ascend.setLoop( false );
	  ascend.setVolume( 0.2 );
    ascend.playbackRate = 0.6;
});
scene.state.aSound = ascend;

var descend = new Audio( listener5 );
audioLoader.load( Descend, function( buffer ) {
    descend.setBuffer( buffer );
	  descend.setLoop( false );
	  descend.setVolume( 0.4 );
    descend.playbackRate = 0.6;
});

const renderScene = new RenderPass( scene, camera );

const bloomPass = new UnrealBloomPass( new Vector2( window.innerWidth, window.innerHeight ), 1.5, 0.4, 0.85 );
bloomPass.threshold = params.bloomThreshold;
bloomPass.strength = params.bloomStrength;
bloomPass.radius = params.bloomRadius;

composer = new EffectComposer( renderer );
composer.addPass( renderScene );
composer.addPass( bloomPass );

const interval = 20;
var prev = 0;
var pause = false;

// Render loop
const onAnimationFrameHandler = (timeStamp) => {
    var v = scene.state.playerPos.clone();
    v.y += 10;
    camera.lookAt(v);
    camera.position.set(v.x, v.y+2, v.z);
    camera.position.add(view);
    scene.state.cameraP.copy(camera.position);

    //add player speed
    var vdir = view.clone();
    vdir.y = 0;
    vdir.multiplyScalar(-0.002);
    if (dir.up) scene.state.playerV.add(vdir);
    if (dir.down) scene.state.playerV.sub(vdir);
    vdir.y = vdir.x*-1;
    vdir.x = vdir.z;
    vdir.z = vdir.y;
    vdir.y = 0;
    if (dir.left) scene.state.playerV.add(vdir);
    if (dir.right) scene.state.playerV.sub(vdir);
    if (scene.state.playerPos.y > 1.3){
        if (scene.state.playerV.y < 0) scene.state.playerV.y -= .01;
        else scene.state.playerV.y -= .006;
        scene.state.playerV.multiplyScalar(0.98);
    }

    if (Math.abs(scene.state.playerPos.x) > 155 || Math.abs(scene.state.playerPos.z) > 155 || scene.state.playerPos.y < 0.0){
        scene.state.playerV.y -= .01;
    } else {
        if (scene.state.playerPos.y < 1.3 && scene.state.playerV.y < 0) scene.state.playerV.y = 0;
    }
    if (scene.state.playerPos.y < -30) scene.state.hurt = true;

    scene.state.playerV.x *= 0.9;
    scene.state.playerV.z *= 0.9;

    if(dir.fire && timeStamp - lastShot > 150 && scene.state.hurt == false && pause == false){
        lastShot = timeStamp;
        if (shots.length > shotIndex) shots[shotIndex].play();
        shotIndex += 1;
        if(shotIndex >= 4) shotIndex = 0;
        scene.state.fire();
    }
    if (timeStamp > prev){
        prev = timeStamp + interval;
        composer.render(scene, camera);
    }
    if (scene.state.hurt) music.setVolume( 0.1 );
    
    if (pause == false) scene.update && scene.update(timeStamp);
    window.requestAnimationFrame(onAnimationFrameHandler);
};
window.requestAnimationFrame(onAnimationFrameHandler);

// Resize Handler
const windowResizeHandler = () => {
    const { innerHeight, innerWidth } = window;
    renderer.setSize(innerWidth, innerHeight);
    composer.setSize( innerWidth,  innerHeight);
    camera.aspect = innerWidth / innerHeight;
    camera.updateProjectionMatrix();
};

function handleImpactEvents(event) {
    if (event.target.tagName === "INPUT") { return; }
    if (event.key == "e") pause = !pause; 
    if (event.key == "w" || event.key == "W") dir.up = true;
    if (event.key == "s" || event.key == "S") dir.down = true;
    if (event.key == "a" || event.key == "A") dir.left = true;
    if (event.key == "d" || event.key == "D") dir.right = true; 
    if (event.key == "r" || event.key == "R") {
        scene.state.reset();
        music.setVolume( 0.4 );
    }
    if (event.key == "q" || event.key == "Q") {
        if (scene.getObjectByName("flower").state.cpow == -1){
            scene.getObjectByName("flower").powerUp();
            if (scene.getObjectByName("flower").state.cpow != -1) descend.play();
            if (scene.getObjectByName("flower").state.cpow == 1) scene.getObjectByName("bomb").set();
        }
    }
    if (event.key == " " && scene.state.playerPos.y <= 1.3) {
        if (Math.abs(scene.state.playerPos.x) <= 155 && Math.abs(scene.state.playerPos.z) <= 155 && scene.state.playerPos.y >= 0.0) scene.state.playerV.y = 0.35;
    }
    if (event.key == "i"){
        document.exitPointerLock = document.exitPointerLock    ||
                           document.mozExitPointerLock;
        document.exitPointerLock();
    }
};
function handleImpactEvents2(event) {
    if (event.target.tagName === "INPUT") { return; }
    if (event.key == "w" || event.key == "W") dir.up = false;
    if (event.key == "s" || event.key == "S") dir.down = false;
    if (event.key == "a" || event.key == "A") dir.left = false;
    if (event.key == "d" || event.key == "D") dir.right = false;
};
function handleMouseEvents(event) {
  if (event.target.tagName === "INPUT") { return; }
    //console.log(event);
    angle.x += event.movementX/500;
    angle.y += event.movementY/500;
    view.z = Math.sin(angle.x)*45;
    view.x = Math.cos(angle.x)*45;
    view.y = Math.sin(angle.y)*45;
};
function handleMouseEvents2(event) {
  if (event.target.tagName === "INPUT") { return; }
    dir.fire = true; //scene.state.fire();
};

function handleMouseEvents3(event) {
  if (event.target.tagName === "INPUT") { return; }
    dir.fire = false; //scene.state.fire();
};

windowResizeHandler();
window.addEventListener('resize', windowResizeHandler, false);
window.addEventListener("keydown", handleImpactEvents);
window.addEventListener("keyup", handleImpactEvents2);
window.addEventListener("mousemove", handleMouseEvents);
window.addEventListener("mousedown", handleMouseEvents2);
window.addEventListener("mouseup", handleMouseEvents3);
